import React from 'react';
import classNames from 'classnames';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Image } from '@fiverr-private/media';
import { Typography, Link, Text, Heading } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { I18n, translate } from '@fiverr-private/i18n-react';
import {
  FRIENDS_BONUS,
  INVITE_MAX_BONUS,
  INVITE_MAX_BONUS_PER_REFERRAL,
  LOGIN_URL,
  TERMS_AND_CONDITIONS_LINKS,
} from '../../../constants';
import guestHeaderImage from '../../assets/header_guest.png';
import regularHeaderImage from '../../assets/header.png';
import xlHeaderImage from '../../assets/header_xl.png';
import { track as mixpanelTrack } from '../../../lib/mixpanel';
import { formatCurrency } from '../../../lib/formatCurrency';
import { useUser } from '../../hooks/useUser';
import { SIGNIN_CLASS_NAME } from './constants';

import { innerClass, innerLoggedClass } from './styles.ve.css';

export const PageHeader = () => {
  const user = useUser();

  const isGuest = !user;

  const translationPrefix = isGuest ? 'guest' : 'user';

  const AccentComponent = (text) => (
    <Typography as="span" color="orange_700">
      {user?.username || text}
    </Typography>
  );

  const termsAndConditionsLink = isGuest
    ? TERMS_AND_CONDITIONS_LINKS.GUEST_HEADER
    : TERMS_AND_CONDITIONS_LINKS.USER_HEADER;

  const onTermsClick = () => {
    mixpanelTrack('Referral Page Inviter - Terms and Conditions - Click', { Place: 'Header' });
  };

  return (
    <Container as="header" backgroundColor="pink_100" height={{ md: '484px' }} display="flex">
      <Stack
        justifyContent={{ md: 'center', xl: 'flexEnd' }}
        alignItems={{ md: 'center' }}
        flex={{ md: '1' }}
        className={classNames(innerClass, { [innerLoggedClass]: !isGuest })}
      >
        <Container maxWidth={{ xl: '700px', lg: '620px' }}>
          <Heading as="h1">
            <I18n
              k={`referral_program_perseus.header.${translationPrefix}.title`}
              templates={{ accent: AccentComponent }}
            />
          </Heading>

          <Text role="doc-subtitle" color="bodyPrimary" size="b_lg">
            <I18n
              k={`referral_program_perseus.header.${translationPrefix}.sub_title`}
              params={{
                friends_bonus: FRIENDS_BONUS,
                max_bonus: formatCurrency(INVITE_MAX_BONUS),
                max_bonus_referral: formatCurrency(INVITE_MAX_BONUS_PER_REFERRAL),
              }}
            />
          </Text>

          {isGuest && (
            <Stack marginTop="5">
              <Button className={SIGNIN_CLASS_NAME} href={LOGIN_URL} size="lg">
                <I18n k={'referral_program_perseus.header.cta'} />
              </Button>
            </Stack>
          )}
          <Container marginTop={{ default: '8', md: '10' }}>
            <Link
              onClick={onTermsClick}
              target="_blank"
              href={termsAndConditionsLink}
              rel="noreferrer"
              decoration={{ default: 'underline', hover: 'none' }}
              color={{ hover: 'grey_1200' }}
            >
              <Text size="b_xs" fontWeight="semibold">
                <I18n k={'referral_program_perseus.header.terms'} />
              </Text>
            </Link>
          </Container>
        </Container>
      </Stack>

      {isGuest ? (
        <Container width={{ lg: '720px', md: '450px' }} hidden={{ md: false, default: true }} flex={{ xl: '1' }}>
          <Image
            src={guestHeaderImage}
            alt={translate('referral_program_perseus.header.header_image')}
            objectFit="cover"
            height="100%"
          />
        </Container>
      ) : (
        <Container
          width={{ default: '450px', lg: '708px', md: '348px' }}
          hidden={{ md: false, default: true }}
          flex={{ xl: '1' }}
        >
          <Image
            src={{ xl: xlHeaderImage, default: regularHeaderImage }}
            alt="header image"
            objectFit="cover"
            height="100%"
            // @ts-expect-error objectPosition is not available
            style={{ objectPosition: '100%' }}
          />
        </Container>
      )}
    </Container>
  );
};
